import {  BuildingLibraryIcon, EnvelopeIcon, GiftIcon } from '@heroicons/react/24/outline'
import React from 'react'

export default function RegistrySweet({sobre,bank,giftRegistry}) {

  return (
    <div className="bg-white font-raleway">
    <div className="mx-auto max-w-7xl  px-4 pb-12 text-center sm:px-6 lg:py-16 lg:px-8">
    {/* <div className="flex justify-center">
            <img
              alt=""
              src="https://nicolexv.pilcrow.mx/assets/images/sec-title-flower.png"
              className="w-32"
            />
          </div>
          <div className="mx-auto max-w-2xl px-4  sm:px-6 lg:max-w-7xl lg:px-8">

          <div className="text-center">
          
          <p className="sm:text-lg text-md text-center  text-gray-500 ">            El regalo más importante es tu presencia
          </p> 
          
        </div>
        </div> */}
      
      <div className=" flex justify-center">
        
        <div className='flex flex-row  justify-evenly gap-8 '>

        {
          sobre &&

          <div className='h-12 overflow-hidden'>
          <img width="80"  class="mx-auto -mt-3" src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Gift_Flat_Icon_Vector.svg/1200px-Gift_Flat_Icon_Vector.svg.png" alt=""></img>  
          </div>
        }
        {
          sobre &&

          <img width="70"  class="mx-auto" src="data:image/jpeg;base64,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" alt=""></img>  
        } 

 




        
        {
          bank &&
          <div className='bg-white shadow-md px-2 py-8 w-64 rounded-xl'>
              <BuildingLibraryIcon className='h-16 mb-2 mx-auto text-rose-300' />
              <p>CLABE : {bank.clabe}</p>
              <p>Nombre del banco : {bank.nameBank}</p>
              <p>Beneficiario :{bank.beneficiary} </p>
          </div>
        }
        {

          giftRegistry &&

          <div className='bg-white shadow-md px-2 py-8 w-64 rounded-xl'>
          <GiftIcon className='h-16 mb-2 mx-auto text-rose-300'/>
              <p>Mesa de regalos : </p>
              <p>Liverpool
              </p>
          </div>
        }
        </div>
      </div>
    </div>
  </div>
  )
}
